import _ from 'lodash';
import { isAfterHoursCurrentlyAvailable } from 'shared/helpers/dispensaries';
import { openInfoForDispensary } from 'shared/core/helpers/dispensaries';

export const getAfterHoursDispensary = (dispensaryChainLocations) =>
  _.find(dispensaryChainLocations, (dispensaryChainLocation) =>
    isAfterHoursCurrentlyAvailable(dispensaryChainLocation)
  );

export const getOpenDispensary = (dispensaryChainLocations) =>
  _.find(dispensaryChainLocations, (dispensaryChainLocation) => {
    const openInfo = openInfoForDispensary(dispensaryChainLocation, {});

    return !!openInfo?.delivery?.isOpen;
  });
